// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Mo-z","badgeLink":"No-z","category":"Oo-z"};